import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

@Component({
  selector: 'bm-summarize-cell',
  templateUrl: './summarize-cell.component.html',
  styleUrls: ['./summarize-cell.component.scss']
})
export class SummarizeCellComponent implements ICellRendererAngularComp {

  cellValue: any;

  agInit({value}): void {
      this.cellValue = value;
  }

  refresh(): boolean {
      return false;
  }
}
